import { render, staticRenderFns } from "./FPZ.vue?vue&type=template&id=2955ec4f&scoped=true"
import script from "./FPZ.vue?vue&type=script&lang=js"
export * from "./FPZ.vue?vue&type=script&lang=js"
import style0 from "./FPZ.vue?vue&type=style&index=0&id=2955ec4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955ec4f",
  null
  
)

export default component.exports